export const GRID_BREAKPOINTS = {
    MOBILE: 0,
    SMALL: 600,
    MEDIUM: 1300,
    LARGE: 1900,
};
